import { render, staticRenderFns } from "./FooterWideFacelift.vue?vue&type=template&id=4d076d90&scoped=true&"
import script from "./FooterWideFacelift.vue?vue&type=script&lang=js&"
export * from "./FooterWideFacelift.vue?vue&type=script&lang=js&"
import style0 from "./FooterWideFacelift.vue?vue&type=style&index=0&id=4d076d90&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d076d90",
  null
  
)

export default component.exports